export default {"src":"/_next/static/media/warning.33be4e3f.svg","height":800,"width":800};